type CurrentNode = {
    id: number
    parents: number[]
}
type Lookup = { [id: number]: { id: number; parents: number[] } }

export function findAncestors(currentNode: CurrentNode, lookup: Lookup) {
    const ancestorIds: number[] = []
    for (const parentId of currentNode.parents) {
        if (!lookup[parentId]) {
            console.warn(`Could not find parent: ${parentId}`) // eslint-disable-line no-console
            continue
        }
        const parentUnit = lookup[parentId]
        ancestorIds.push(parentId)
        ancestorIds.push(...findAncestors(parentUnit, lookup))
    }
    return ancestorIds
}
